import { createSelector } from 'reselect';

const getState = state => state.intl;
export const selectCurrentLocale = createSelector(getState, intl => intl.locale);